import { forwardRef } from '@heroui/system';
import { Slider, SliderProps, extendVariants } from '@heroui/react';

export const CustomInputRange = extendVariants(Slider, {
  variants: {
    size: {
      sm: {
        track: 'h-1.25',
      },
    },
    color: {
      primary: {
        track: 'border-s-base-20 bg-base-40',
        filler: 'bg-base-20',
        thumb: 'size-3.5! bg-base-10 ring-base-10 shadow-none after:size-3.5! after:bg-base-10',
      },
    },
  },
  defaultVariants: {
    color: 'primary',
    size: 'sm',
  },
});

export interface CustomSliderProps extends Omit<SliderProps, 'ref'> {}

const InputRange = forwardRef<'input', CustomSliderProps>((props, ref) => {
  return <CustomInputRange ref={ref} {...props} />;
});

export default InputRange;
